<template>
  <div id="shop">
    <transition name="fade" mode="out-in">
      <div
        v-if="loading"
        class="loading"
        style="height: 100vh; background: orange"
        key="loading"
      >
        <pulse-loader
          color="#ffffff"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -28.5px;
            margin-top: -12px;
          "
        ></pulse-loader>
      </div>
      <div v-else-if="line_error">
        <error-page></error-page>
      </div>
      <div v-else-if="error">
        <error-page></error-page>
      </div>
      <div v-else key="cotent" style="overflow-x: hidden">
        <div
          style="
            background: white;
            min-height: 100vh;
            max-width: 380px;
            width: 100%;
            margin: auto;
            border: 1px solid #eee;
          "
        >
          <div class="container-fluid">
            <div class="row" style="margin-top: 15px; margin-bottom: 15px">
              <div class="col-xs-1"></div>
              <div class="col-xs-5 text-right">
                <div
                  style="
                    background: #eee;
                    padding: 10px 15px 5px 15px;
                    border: 1px solid #eee;
                    border-radius: 30px;
                    font-size: 15px;
                    position: relative;
                  "
                >
                  <img
                    :src="'./img/shop/coin_plus_icon.png'"
                    alt=""
                    style="
                      width: 55px;
                      position: absolute;
                      left: 0;
                      margin-left: -27.5px;
                      top: 50%;
                      margin-top: -27.5px;
                    "
                  /><span>{{ current_coin | numberFormat }}</span>
                </div>
              </div>
              <div class="col-xs-1"></div>
              <div class="col-xs-5 text-right" @click="currentView = 'diamond'">
                <div
                  style="
                    background: #eee;
                    padding: 10px 15px 5px 15px;
                    border: 1px solid #eee;
                    border-radius: 30px;
                    font-size: 15px;
                    position: relative;
                  "
                >
                  <img
                    :src="'./img/shop/diamond_plus_icon.png'"
                    alt=""
                    style="
                      width: 55px;
                      position: absolute;
                      left: 0;
                      margin-left: -27.5px;
                      top: 50%;
                      margin-top: -27.5px;
                    "
                  /><span>{{ animatedDiamond | numberFormat }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class=""
            style="
              border-radius: 5px;
              background: #ff2437;
              overflow: auto;
              margin: 15px;
              color: white;
              cursor: pointer;
            "
            @click="currentView = 'line'"
          >
            <div class="col-xs-4 text-center" style="padding: 0">
              <img
                :src="'./img/shop/item_tuinui_sticker_1.png'"
                alt=""
                class="img-responsive"
                style="margin: auto"
              />
            </div>
            <div class="col-xs-8" style="padding: 0px 10px">
              <h5 style="line-height: 23px">
                สติ๊กเกอร์ TUINUI Fat Bear Vol.1 มาแล้วจ้า!! <br />
                คลิ๊กเพื่อดู
              </h5>
            </div>
          </div>
          <div>
            <div
              class="pole"
              :style="{ 'background-image': 'url(./img/shop/pole_shop.png)' }"
              style="padding: 0 20px"
            >
              <a
                href="javascript:void(0);"
                class="shop-nav-link"
                :class="{ active: currentView == 'potion' }"
                @click="currentView = 'potion'"
                ><img
                  :src="'./img/shop/item_shop.png'"
                  alt=""
                  style="width: 80px; margin-right: 3px"
              /></a>
              <a
                href="javascript:void(0);"
                class="shop-nav-link"
                :class="{ active: currentView == 'diamond' }"
                @click="currentView = 'diamond'"
                ><img
                  :src="'./img/shop/diamond_shop.png'"
                  alt=""
                  style="width: 80px; margin-right: 3px"
              /></a>
              <a
                href="javascript:void(0);"
                class="shop-nav-link"
                :class="{ active: currentView == 'line' }"
                @click="currentView = 'line'"
                ><img
                  :src="'./img/shop/line_shop.png'"
                  alt=""
                  style="width: 80px"
              /></a>
            </div>
          </div>

          <div>
            <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->
            <div
              class="container-fluid"
              v-show="currentView == 'potion'"
              key="potion"
            >
              <ul class="item-list">
                <li v-for="item in items.potion" :key="'item_' + item.code">
                  <div class="item row" @click="buyItem(item)">
                    <div class="item-image col-xs-4">
                      <img :src="item.image" alt="" style="width: 100%" />
                    </div>
                    <div class="item-detail col-xs-8">
                      <h3 class="title">{{ item.name }}</h3>
                      <p class="small">{{ item.description }}</p>

                      <div class="text-right">
                        <div class="price">
                          <img
                            :src="'./img/shop/' + item.type + '_icon.png'"
                            alt=""
                            class="icon"
                          /><template v-if="item.discount"
                            ><span
                              style="
                                text-decoration: line-through;
                                margin-right: 5px;
                              "
                              >{{ item.discount | numberFormat }}</span
                            >-> </template
                          ><span
                            :style="{ color: item.discount ? 'red' : '' }"
                            >{{ item.value | numberFormat }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="container-fluid"
              v-show="currentView == 'diamond'"
              key="diamond"
            >
              <ul class="item-list">
                <li
                  v-for="item in items.diamond"
                  :key="'item_' + item.code"
                  @click="openLinePay(item)"
                >
                  <div class="item row">
                    <div class="item-image col-xs-4">
                      <img :src="item.image" alt="" style="width: 100%" />
                    </div>
                    <div class="item-detail col-xs-8">
                      <h3 class="title">{{ item.name }}</h3>
                      <!-- <p class="small">{{ item.description }}</p> -->

                      <div class="text-right" style="margin-top: 35px">
                        <div class="price">
                          <span>฿ {{ item.value | numberFormat }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="container-fluid"
              v-show="currentView == 'line'"
              key="line"
            >
              <ul class="item-list">
                <li v-for="item in items.line" :key="'item_' + item.code">
                  <div class="item row" @click="openLink(item)">
                    <div class="item-image col-xs-4">
                      <img :src="item.image" alt="" style="width: 100%" />
                    </div>
                    <div class="item-detail col-xs-8">
                      <h3 class="title">{{ item.name }}</h3>
                      <!-- <p class="small">{{ item.description }}</p> -->

                      <div class="text-right" style="margin-top: 35px">
                        <div class="price">
                          <span>฿ {{ item.value | numberFormat }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- </transition> -->
          </div>
        </div>
      </div>
    </transition>

    <modal-shop v-if="showModal" @close="showModal = false">
      <template slot="header"> Buy </template>
      <template v-if="order">
        <template
          v-if="order.type == 'diamond' && current_diamond < order.value"
        >
          <div class="text-center" slot="body">
            <img
              :src="'./img/shop/diamond_plus_icon.png'"
              class="img-responsive"
              style="margin: auto"
            />
            <h4>Not have enough diamond to buy {{ order.name }}</h4>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = false">
              Close
            </button>
            <button
              class="btn btn-primary"
              @click="
                currentView = 'diamond';
                showModal = false;
              "
            >
              Buy Diamond
            </button>
          </div>
        </template>
        <template
          v-else-if="order.type == 'coin' && current_coin < order.value"
        >
          <div class="text-center" slot="body">
            <img
              :src="'./img/shop/coin_plus_icon.png'"
              class="img-responsive"
              style="margin: auto"
            />
            <h4>Not have enough coin to buy {{ order.name }}</h4>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = false">
              Close
            </button>
          </div>
        </template>
        <template v-else>
          <div class="text-center" slot="body">
            <img
              :src="order.image"
              class="img-responsive"
              style="margin: auto"
            />
            <h4>Are you sure to buy {{ order.name }}?</h4>
          </div>
          <div slot="footer">
            <template v-if="!loadingPayment">
              <button class="btn btn-default" @click="showModal = false">
                Close
              </button>
              <button class="btn btn-primary" @click="confirmBuy()">Buy</button>
            </template>
            <template v-else>
              <pulse-loader color="#ffa500"></pulse-loader>
            </template>
          </div>
        </template>
      </template>
    </modal-shop>
    <modal-shop v-if="showPayment" @close="showPayment = false">
      <template slot="header">&nbsp;</template>
      <div class="text-center" slot="body">
        <template v-if="isPaymentComplete">
          <div v-if="order.code == 'gacha_1'">
            <template v-if="order.response != 'Duplicate Tuinui'">
              <div
                style="
                  width: 100%;
                  padding: 15px;
                  background: black;
                  border-radius: 5px;
                "
              >
                <img
                  :src="
                    './img/shop/tuinui/evolve_' +
                    order.current_tuinui_id +
                    '.png'
                  "
                  class="img-responsive"
                  style="margin: auto"
                />
              </div>
              <p class="text-center">
                สามารถเลือกดู Tuinui หรือเปลี่ยนตุ้ยนุ้ยได้ที่หน้า status
              </p>
            </template>
            <template v-else>
              <div
                style="
                  width: 100%;
                  padding: 15px;
                  background: #08f;
                  border-radius: 5px;
                "
              >
                <img
                  :src="'./img/shop/diamond_icon.png'"
                  class="img-responsive"
                  style="margin: auto"
                />
                <h3 style="color: white">Diamond +10</h3>
              </div>
            </template>
          </div>
          <div v-else-if="order.code == 'reset_0'">
            <div
              style="
                width: 100%;
                padding: 15px;
                background: #767a7d;
                border-radius: 5px;
              "
            >
              <img
                :src="'./img/shop/hatch_new_egg.png'"
                class="img-responsive"
                style="margin: auto"
              />
            </div>
          </div>
          <div v-else-if="order.code == 'reset_stat'">
            <div
              style="
                width: 100%;
                padding: 15px;
                background: #96d2ff;
                border-radius: 5px;
              "
            >
              <img
                :src="'./img/shop/eat_drug.png'"
                class="img-responsive"
                style="margin: auto"
              />
            </div>
          </div>
          <div v-else-if="order.code == 'reset_energy'">
            <div
              style="
                width: 100%;
                padding: 15px;
                background: rgb(188, 255, 177);
                border-radius: 5px;
              "
            >
              <img
                :src="'./img/shop/full_energy.png'"
                class="img-responsive"
                style="margin: auto"
              />
            </div>
          </div>

          <h4 style="color: green" v-if="order.response != 'Duplicate Tuinui'">
            {{ order.response }}
          </h4>
          <h4 style="color: green" v-else>เกลือครับผม!!</h4>
        </template>
        <template v-else>
          <img
            :src="'./img/shop/fail_mark.png'"
            class="img-responsive"
            style="max-width: 150px; margin: auto"
          />
          <h4 style="color: red">
            Your payment was not successful. Please try again.
          </h4>
        </template>
      </div>

      <div class="text-center" slot="footer">
        <button class="btn btn-primary" @click="showPayment = false">
          Close
        </button>
      </div>
    </modal-shop>
  </div>
</template>

<script>
import ErrorPage from "@/views/components/ErrorPage.vue";

import $ from "jquery";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import numeral from "numeral";
import ModalShop from "@/views/components/ModalShop";
import { TweenLite } from "gsap/TweenMax";

export default {
  data: function () {
    return {
      level: 1,
      userid: null, //U15dcdd6825d0efae99fb8f144ed7cfd1
      loading: true,
      loadingPayment: false,
      line_error: false,
      current_diamond: 0,
      tweenedDiamond: 0,
      current_coin: 0,
      error: false,

      order: null,
      showModal: false,
      showPayment: false,
      isPaymentComplete: false,

      currentView: "potion",

      items: {
        potion: [
          {
            image: "./img/shop/item_reenergy.png",
            name: "Re-energy",
            description: "รีเซต energy ให้เต็ม",
            code: "reset_energy",
            value: 10,
            type: "diamond",
            discount: null,
          },
          {
            image: "./img/shop/item_tuinui_card.png",
            name: "Tuinui Card",
            description: "สุ่มตุ้ยนุ้ยการ์ดเพื่อสะสมและนำไปแปลงร่าง",
            code: "gacha_1",
            value: 20,
            type: "diamond",
            discount: 40,
          },
          {
            image: "./img/shop/item_egg.png",
            name: "New tuinui egg",
            description: "กลับไป level 1 และเลือกไข่ตุ้ยนุ้ยใหม่",
            code: "reset_0",
            value: 20,
            type: "diamond",
            discount: null,
          },
          {
            image: "./img/shop/item_pill.png",
            name: "Re-stat pill",
            description: "รีเซต stat point ทั้งหมด",
            code: "reset_stat",
            value: 50,
            type: "diamond",
            discount: null,
          },
          // {
          //     image : './img/shop/item_crystal.png',
          //     name : 'Transform crystal',
          //     description: 'เปลี่ยนร่างตุ้ยนุ้ยแบบสุ่ม',
          //     code: 'transform_potion',
          //     value: 150,
          //     type: 'diamond'
          // }
        ],
        diamond: [
          {
            image: "./img/shop/item_diamond_small.png",
            name: "Diamond x 50",
            code: "tuinui_diamondx50",
            value: 50,
            type: "diamond",
          },
          {
            image: "./img/shop/item_diamond_medium.png",
            name: "Diamond x 120",
            code: "tuinui_diamondx100",
            value: 100,
            type: "diamond",
          },
          {
            image: "./img/shop/item_diamond_large.png",
            name: "Diamond x 250",
            code: "tuinui_diamondx200",
            value: 200,
            type: "diamond",
          },
        ],
        line: [
          {
            image: "./img/shop/item_tuinui_sticker_1.png",
            name: "TUINUI Fat Bear Vol.1 (Sticker)",
            link: "https://line.me/S/sticker/4952451",
            code: "tuinui_v1",
            value: 30,
            type: "diamond",
          },
        ],
      },
    };
  },
  components: {
    PulseLoader,
    ErrorPage,
    ModalShop,
  },
  computed: {
    animatedDiamond: function () {
      return numeral(this.tweenedDiamond).format("0,0");
    },
  },
  mounted: async function () {
    this.loading = true;

    try {
      await this.$liff.init({
        liffId: process.env.VUE_APP_LIFF_ID_SHOP, // Use own liffId
      });
      if (this.$liff.isLoggedIn()) {
        const profile = await this.$liff.getProfile();
        this.display_name = profile.displayName;
        this.userid = profile.userId;
        await this.loadProfile();
        this.loading = false;
      } else this.$liff.login();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.line_error = true;
    }
    this.loading = false;
  },
  methods: {
    loadProfile: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      return new Promise((resolve, reject) => {
        $.ajax({
          url:
            SERVER_URL +
            "getuserprofile?userid=" +
            vm.userid +
            "__148369119115215",
          type: "GET",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (result) {
            if (result.responsecode == 200 && result.data != null) {
              var row = result.data[0];

              vm.current_diamond = parseInt(row.current_diamond);
              vm.level = row.current_level;

              resolve();
            } else {
              vm.error = true;
              reject();
            }
          },
          error: function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            vm.error = true;
            reject();
          },
        });
      });
    },
    buyItem: function (item) {
      var vm = this;
      // if (vm.level < 25 && item.code == 'gacha_1') {
      //     return false
      // }
      vm.order = item;

      vm.showModal = true;
    },
    confirmBuy: function () {
      var vm = this;
      if (vm.order.type == "diamond" && vm.current_diamond < vm.order.value) {
        return false;
      } else if (vm.order.type == "coin" && vm.current_coin < vm.order.value) {
        return false;
      } else {
        const SERVER_URL = "https://caloriesbot.herokuapp.com/";
        var data = {
          userid: vm.userid + "__148369119115215",
          itemname: vm.order.code,
        };

        vm.loadingPayment = true;
        $.ajax({
          url: SERVER_URL + "buyitem",
          type: "POST",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(data),
          success: function (result) {
            if (result.responsecode == 200) {
              // console.log(result.data)
              vm.order.response = result.log;
              if (result.current_tuinui_id) {
                vm.order.current_tuinui_id = result.current_tuinui_id;
              }
              vm.loadingPayment = false;
              vm.showModal = false;
              vm.current_diamond = result.current_diamond;
              vm.isPaymentComplete = true;
              vm.showPayment = true;
            } else {
              vm.loadingPayment = false;
              vm.showModal = false;
              vm.isPaymentComplete = false;
              vm.showPayment = true;
            }
          },
          error: function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            vm.loadingPayment = false;
            vm.showModal = false;
            vm.isPaymentComplete = false;
            vm.showPayment = true;
          },
        });
      }
    },
    openLinePay: function (item) {
      window.open(
        "http://zwiz.ai/phpgateway/linepay.php?productname=" +
          item.code +
          "&userid=" +
          this.userid +
          "__148369119115215",
        "_blank"
      );
      setTimeout(() => {
        if (this.$liff.isInClient()) this.$liff.closeWindow();
      }, 5000);
    },
    openLink: function (item) {
      window.open(item.link, "_blank");
      setTimeout(() => {
        if (this.$liff.isInClient()) this.$liff.closeWindow();
      }, 5000);
    },
  },
  watch: {
    current_diamond: function (newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedDiamond: newValue });
    },
  },
};
</script>

<style scoped></style>
